// Account Receivable Statements Getters

export const getStatementsList = state => {
  return state.statementsList
}

export const getStatementInfo = state => {
  return state.statementInfo
}

export const getCashOrOpenList = state => {
  return state.cashOrOpen
}
